import { BridgeComponent } from "@hotwired/hotwire-native-bridge";
import { SupercastTimeUpdateEvent } from "utils/events";

export default class PlaybackListenerController extends BridgeComponent {
  static component = "playback-listener";

  connect() {
    this.send("connect", {}, this.handlePlaybackResponse.bind(this));
  }

  handlePlaybackResponse(message) {
    const event = new SupercastTimeUpdateEvent({
      itemId: message.data.itemId,
      itemType: message.data.itemType,
      currentTime: message.data.time,
      duration: message.data.duration,
      isPlaying: message.data.isPlaying,
      mediaType: message.data.mediaType || "audio"
    });

    window.dispatchEvent(event);
  }
}